// =====================================
//	重設密碼 modal
//	@author: Tim
//	@time 2016 / 03 / 04
// =====================================

window.InifECApp.directive('resetPwModal', ['$rootScope', '$ngModal', '$timeout', '$state', 'UserService',
    function($rootScope, $ngModal, $timeout, $state, UserService) {
    return {
        restrict: "E",
        scope: true,
        templateUrl: "partials/modal/reset_pw.html",
        link: function(scope, element, attrs) {},
        controller: ['$scope', function($scope) {

            var init = function() {}

            var cancelReset = function() {
                $state.go(window.STATES.HOME);
                $ngModal.closeModal('reset-pw-modal');
            }

            var closeReset = function() {
                $ngModal.closeModal('reset-pw-modal');
            }

            var resetPwByEmail = function() {
                if ($scope.isUpdating) {
                    return;
                }
                $scope.isError = false;
                $scope.isResetSuccess = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
                $scope.isCheckError = false;
                $scope.errorMsg = "";

                if ($scope.email == "" || $scope.token == "") {
                    $scope.isError = true;
                    $scope.errorMsg = '系統忙碌中，請稍後再試';
                    return;
                }

                if (!$scope.form.pwd) {
                    $scope.isPwdEmpty = true;
                }

                if (!$scope.form.repwd) {
                    $scope.isRePwdEmpty = true;
                }

                if($scope.form.pwd && $scope.form.repwd &&
                   $scope.form.pwd != $scope.form.repwd) {
					$scope.isCheckError = true;
					$scope.errorMsg = '兩次的密碼輸入的不一致';
				}

				if($scope.isPwdEmpty || $scope.isRePwdEmpty || $scope.isCheckError) {
					return;
				}

				$scope.isUpdating = true;

				UserService.updPassword($scope.token, $scope.form.pwd, $scope.email).then(function(result) {
					if(result) {
						$scope.isUpdating = false;
						$scope.isResetSuccess = true;

                        $rootScope.$broadcast("OPEN_SUCCESS_MESSAGE_MODAL", {
                            title: '密碼重設成功',
                            desc: '您的密碼已重設，往後請使用新密碼登入！'
                        });

						cancelReset();
					}
				}, function(error) {
					$scope.isError = true;
					$scope.isUpdating = false;
					$scope.errorMsg = error.message || '系統忙碌中，請稍後再試';
				});
            }

            var resetFormdata = function() {
                $scope.form.pwd = '';
                $scope.form.repwd = '';

                $scope.errorMsg = "";

                $scope.isError = false;
                $scope.isResetSuccess = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
                $scope.isCheckError = false;
                $scope.isUpdating = false;

                $scope.isoldPwdEmpty = false;
                $scope.isPwdEmpty = false;
                $scope.isRePwdEmpty = false;
            }

            /*==========================
            	Events
            ==========================*/

            $scope.$on("OPEN_RESET_PW_MODAL", function(e, data) {
                resetFormdata();
                $scope.email = data.email;
                $scope.token = data.token;
                $ngModal.openModal('reset-pw-modal');
            });

            /*==========================
            	Members
            ==========================*/

            $scope.email = "";
            $scope.token = "";
            $scope.errorMsg = "";

            $scope.isError = false;
            $scope.isResetSuccess = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;
            $scope.isCheckError = false;
            $scope.isUpdating = false;

            $scope.isoldPwdEmpty = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;

            $scope.form = {
                pwd: '',
                repwd: '',
            };

            /*==========================
            	Methods
            ==========================*/
            $scope.cancelReset = cancelReset;
            $scope.closeReset = closeReset;
            $scope.resetPwByEmail = resetPwByEmail;

            /*==========================
            	init
            ==========================*/
        }]
    }
}]);
